import { useState } from "react";
import { Trans, useTranslation } from 'react-i18next';
import classes from './MepServices.module.scss';
import arrow from '../../../assets/img/Home/WhyChoose/arrow.png';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Grid } from "swiper";
import "swiper/css";
import 'swiper/css/grid';
import image_01 from '../../../assets/img/Home/MepServices/image_01.avif';
import image_02 from '../../../assets/img/Home/MepServices/image_02.avif';
import image_03 from '../../../assets/img/Home/MepServices/image_03.avif';
import icon_01 from '../../../assets/img/Home/MepServices/icon_01.svg';
import icon_02 from '../../../assets/img/Home/MepServices/icon_02.svg';
import icon_03 from '../../../assets/img/Home/MepServices/icon_03.svg';
import Button from "../../GlobalComponents/Button/Button";

const cards = [
    {
        image: image_01,
        icon: icon_01,
        route: 'services/plumbing',
        subtitle: 'home.mep-services.card_01.subtitle',
        desc: 'home.mep-services.card_01.desc',
        list: [
            'home.mep-services.card_01.li_01',
            'home.mep-services.card_01.li_02',
            'home.mep-services.card_01.li_03',
            'home.mep-services.card_01.li_04',
            'home.mep-services.card_01.li_05',
            'home.mep-services.card_01.li_06',
            'home.mep-services.card_01.li_07',
        ],
    },
    {
        image: image_02,
        icon: icon_02,
        route: 'services/mechanical-works',
        subtitle: 'home.mep-services.card_02.subtitle',
        desc: 'home.mep-services.card_02.desc',
        list: [
            'home.mep-services.card_02.li_01',
            'home.mep-services.card_02.li_02',
            'home.mep-services.card_02.li_03',
            'home.mep-services.card_02.li_04',
            'home.mep-services.card_02.li_05',
        ],
    },
    {
        image: image_03,
        icon: icon_03,
        route: 'services/electrical-services',
        subtitle: 'home.mep-services.card_03.subtitle',
        desc: 'home.mep-services.card_03.desc',
        list: [
            'home.mep-services.card_03.li_01',
            'home.mep-services.card_03.li_02',
            'home.mep-services.card_03.li_03',
            'home.mep-services.card_03.li_04',
            'home.mep-services.card_03.li_05',
            'home.mep-services.card_03.li_06',
        ],
    },
];

const MepServices = () => {
    const { t } = useTranslation();
    const [current, setCurrent] = useState(0);
    const [swiper, setSwiper] = useState({});
    return (
        <section className="mt container">
            <div className={classes.wrap}>
                <div className={classes.head}>
                    <h2 className={`${classes.title} font-48`}>
                        <Trans>
                            {t('home.mep-services.title')}
                        </Trans>
                    </h2>
                    <p className={`${classes.text} font-16`}>
                        {t('home.mep-services.text')}
                    </p>
                </div>
                <div className={classes.swiperWrap}>
                    <div className={classes.swiperContainer}>
                        <Swiper
                            modules={[Grid, Navigation]}
                            className={`${classes.swiper} no-select`}
                            spaceBetween={20}
                            slidesPerView={1}
                            grid={{
                                rows: 1,
                                cols: 1,
                                fill: "row",
                            }}
                            grabCursor
                            onInit={(e) => { setSwiper(e) }}
                            onSlideChange={(e) => setCurrent(e.activeIndex)}
                            breakpoints={{
                                992: {
                                    slidesPerView: 3,
                                    grid: {
                                        rows: 1,
                                        cols: 3,
                                        fill: "row",
                                    },
                                },
                                700: {
                                    slidesPerView: 2,
                                    grid: {
                                        rows: 1,
                                        cols: 2,
                                        fill: "row",
                                    },
                                },
                            }}
                        >
                            {cards.map((card, index) =>
                                <SwiperSlide key={index} className={classes.swiperSlide}>
                                    <div className={classes.card}>
                                        <img className={classes.image} src={card.image} alt='' />
                                        <div className={classes.content}>
                                            <div>
                                                <div className={classes.heading}>
                                                    <div className={classes.iconWrap}>
                                                        <img className={classes.icon} src={card.icon} alt='' />
                                                    </div>
                                                    <h4 className={`${classes.subtitle} font-20`}>
                                                        {t(card.subtitle)}
                                                    </h4>
                                                </div>
                                                <p className={`${classes.desc} font-16`}>
                                                    {t(card.desc)}
                                                </p>
                                                <ul className={`${classes.list} font-16`}>
                                                    {card.list.map((li, index) =>
                                                        <li key={index}>
                                                            {t(li)}
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                            <div>
                                                <Button route={card.route}>
                                                    {t('btn.see-more')}
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            )}
                        </Swiper>
                    </div>
                    <div className={classes.navigation}>
                        <div
                            className={`${classes.arrow} ${current === 0 && classes.arrowInactive}`}
                            onClick={() => swiper.slidePrev()}
                        >
                            <img src={arrow} alt='' />
                        </div>
                        <div
                            className={`${classes.arrow} ${current === 2 && classes.arrowInactive}`}
                            onClick={() => swiper.slideNext()}
                        >
                            <img src={arrow} alt='' />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MepServices;
